import { IconButton, InputAdornment, TextField } from "@mui/material";
import InputMask from "react-input-mask";
import { useState } from "react";
import ClearInputIcon from "../Vectors/ClearInputIcon";

const DelendMaskedField = (props) => {

  const [isValid, setIsValid] = useState(true)  


  const handleChange = (event) => {
    const valor = event.target.value;
      if (props.errorRule !== undefined) {
         setIsValid(props.errorRule(valor))
      }
    return  props.onChange(event)
  }

  const handleClearInputIconClick = () => {
    props.clear(props.name);
    document.getElementById(props.name).value = '';
  }


  return (
    <InputMask
      mask={props.mask}
      disabled={false}
      value={props.value}
      name={props.name}
      maskChar=" "
      onChange={handleChange}
    >
      {() => (
        <TextField
          required
          label={props.label}
          error={!isValid}
          helperText={!isValid  ? props.helperText : " "}
          id={props.name}
          name={props.name}
          value={props.value}
          prefix={props.prefix}
          onChange={handleChange}
          variant={props.variant}
          fullWidth
          style={{
            fontSize: 12,
            '& .MuiFormLabelRoot': {
               fontSize: 12,
               lineHeight : '18px'
          }}}
          color="secondary"
          InputLabelProps={{
              style: { color: '#8087A6', fontSize: 14, lineHeight : '24px' }
          }}
          InputProps={{
            ...props.inputProps,      
            endAdornment: props.value && !isValid  ? (
              <InputAdornment sx={{marginRight: '-5px'}} position="end">
                <IconButton
                  aria-label="Apagar campo"
                  onClick={handleClearInputIconClick}
                >
                  <ClearInputIcon></ClearInputIcon>
                </IconButton>
              </InputAdornment>
            ) : ''
          }}
        />
      )}
    </InputMask>
  );
};

export default DelendMaskedField;
